import { render, staticRenderFns } from "./CategroyName.vue?vue&type=template&id=b6d05804&scoped=true"
import script from "./CategroyName.vue?vue&type=script&lang=ts"
export * from "./CategroyName.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CategroyName.vue?vue&type=style&index=0&id=b6d05804&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b6d05804",
  "a7c3e7d8"
  
)

export default component.exports